import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { InvitationDataType } from '@/types/wireTypes';

export type UserInfoType = {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  middle_name?: string;
  mobile_phone: string;
  type: 'op_co' | 'business';
  language: 'en';
  date_verified: string;
  invitation_data?: InvitationDataType;
};

export const getUserInfoApi = async (userId: string): Promise<ApiResponseType<UserInfoType>> => {
  const uri = `/organization/users/${userId}/`;

  return authApiService.GET(uri);
};
